import * as I18n from 'circe/I18n';
import { NAME as AUTH_NAME } from 'domain/fuse/constants';

export const NAME = `${AUTH_NAME}/AUTH`;
export const REDUCER_NAME = 'auth';
// FORMS
export const CONFIRM_FORM_NAME = 'confirmation';
export const LOGIN_FORM_NAME = 'login';
export const RESET_PASSWORD_FORM_NAME = 'resetPassword';
export const FORGOT_PASSWORD_FORM_NAME = 'forgotPassword';
export const SIGNUP_FORM_NAME = 'signup';

export const USER_DATA_KEY = 'userData';
export const AUTHORITIES = {
  AUTHENTICATED: 'AUTHENTICATED',
  SHIPPER: 'SHIPPER',
  OPERATOR: 'OPERATOR',
  CEO: 'CEO',
  ACCOUNT_ADMIN: 'ACCOUNT_ADMIN',
  DRIVER: 'DRIVER',
  VISITOR: 'VISITOR',
  SYSTEM_ADMIN: 'SYSTEM_ADMIN',
  FINANCE_ADMIN: 'FINANCE_ADMIN',
  DOMAIN_ADMIN: 'DOMAIN_ADMIN',
  FLEET_ADMIN: 'FLEET_ADMIN',
  SELF: 'SELF',
  WAREHOUSE_ADMIN: 'WAREHOUSE_ADMIN',
  WAREHOUSE_OPS_MANAGER: 'WAREHOUSE_OPS_MANAGER',
  WAREHOUSE_PACKER: 'WAREHOUSE_PACKER',
  WAREHOUSE_PICKER: 'WAREHOUSE_PICKER',
  WAREHOUSE_SHIPPER: 'WAREHOUSE_SHIPPER',
  CASHIER: 'CASHIER',
  DISPATCHER: 'DISPATCHER',
  CALL_CENTER_ASSOCIATE: 'CALL_CENTER_ASSOCIATE',
};

export const ROLES = {
  SHIPPER: I18n.str('shipper', 'Shipper'),
  OPERATOR: I18n.str('dispatcher', 'Dispatcher'),
  CEO: I18n.str('ceo', 'CEO'),
  ACCOUNT_ADMIN: I18n.str('accountAdmin', 'Account Admin'),
  DRIVER: I18n.str('driver', 'Driver'),
  SYSTEM_ADMIN: I18n.str('systemAdmin', 'System Admin'),
  FINANCE_ADMIN: I18n.str('financeAdmin', 'Finance Admin'),
  DOMAIN_ADMIN: I18n.str('domainAdmin', 'Domain Admin'),
  FLEET_ADMIN: I18n.str('fleetAdmin', 'Fleet Admin'),
  WAREHOUSE_ADMIN: I18n.str('warehouseAdmin', 'Warehouse Admin'),
  WAREHOUSE_OPS_MANAGER: I18n.str('warehouseOpsManager', 'Warehouse Operations Manager'),
  WAREHOUSE_PACKER: I18n.str('warehousePacker', 'Warehouse Packer'),
  WAREHOUSE_PICKER: I18n.str('warehousePicker', 'Warehouse Picker'),
  WAREHOUSE_SHIPPER: I18n.str('warehouseShipper', 'Warehouse Shipper'),
  CASHIER: I18n.str('cashier', 'Cashier'),
  DISPATCHER: I18n.str('dispatcher', 'Dispatcher'),
  CALL_CENTER_ASSOCIATE: I18n.str('callCenterAssociate', 'Call Center Associate'),
};

export const ACCOUNT_TYPES = [
  {
    value: 'SHIPPER',
    label: I18n.str('vendor', 'Vendor'),
  },

  {
    value: 'COURIER',
    label: I18n.str('transporter', 'Transporter'),
  },
];
